export default __webpack_public_path__ + "static/media/image-queue-loader.258f3aa3.svg";